/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  cleanUpAdminCustomerDetailsRepayment,
} from '../../../utils/helpers';
import useCustomQuery from '../../../network/useCustomQuery';
import useGetQueryParams from '../../../customHooks/useGetQueryParams';
import { GET_ADMIN_CUSTOMER_DETAILS_REPAYMENT } from '../../../graphql/admin_queries';
import AdminTable from '../../../components/AdminTable';
import DashboardHeader from '../../../components/DashboardHeader';
import useToast from '../../../customHooks/useToast';
import useFilterMethods from '../../../customHooks/useFilterMethods';
import EmptyRecord from '../../../components/EmptyRecord';
import useTableColumn from '../../../customHooks/useTableColumn';
import generatePDF from '../../../utils/generatePdf';
import generateCSV from '../../../utils/generateCSV';
import EmptyMerchantSettlement from '../../../svgs/EmptyMerchantSettlement';
import './CustomerDetailsRepayment.scss';
// import CommentModal from '../../merchantDetail/Comment/CommentModal';

const limit = 14;
interface IRepaymentRecords{
defaultUrl?:string;
toggleStorageId?:string;
tabStatus?:string;
hasNameAndImage?:boolean;
merchantId?:any;
}
const CustomerDetailsRepaymentRecords = ({
  defaultUrl, toggleStorageId, tabStatus, hasNameAndImage, merchantId,
}:IRepaymentRecords) => {
  const Toast = useToast();
  const [getRepayment, getRepaymentLoading, repayments] = useCustomQuery({
    query: GET_ADMIN_CUSTOMER_DETAILS_REPAYMENT,
    onError: () => {},
    onData: () => {},
  });

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();
  const allColumns = [
    'id',
    'amountDue',
    'tenor',
    // 'instalments',
    'interest',
    'defaultCharges',
    'paymentChannel',
    'status',
    'repaymentdueDate',
    'payDate',
  ];
  const columnLabelFormat = {
    id: 'Repayment ID',
    amountDue: 'Amount',
    tenor: 'Loan Tenor',
    // instalments: 'Instalments',
    interest: 'Interest Rate',
    defaultCharges: 'Default Charge',
    paymentChannel: 'Payment Method',
    // status: 'Status',
    repaymentdueDate: 'Due Date',
    payDate: 'Date Paid',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [repaymentRec, setRepaymentRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`${defaultUrl}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`${defaultUrl}?page=1&search=${encodeURIComponent(e.target.value)}`);
  };
  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getRepayment({
        variables: tabStatus ? {
          userId: merchantId,
          offset: (page - 1) * limit,
          limit,
          search,
          filters: {
            from: result.from,
            to: result.to,
            channel: result?.channel,
            status: result?.status,
          },
        } : {
          userId: merchantId,
          offset: (page - 1) * limit,
          limit,
          search,
          filters: {
            from: result.from,
            to: result.to,
            channel: result?.channel,
            status: result?.status,
          },
        },
      });
    }
  }, [page, search]);

  const onFilterSubmit = (result) => {
    getRepayment({
      variables: {
        userId: merchantId,
        offset: 0,
        limit,
        search,
        filters: {
          from: result.from,
          to: result.to,
          channel: result?.channel,
          status: result?.status,
        },
      },
    });
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['dateRange', 'status'],
    defaultUrl,
    cb: onFilterSubmit,
    Toast,
    customFilterInformation: {
      dateRange: {
        label: 'Period',
      },
      status: {
        label: 'Status',
        options: [
          {
            label: 'Paid',
            value: 'paid',
          },
          {
            label: 'Unpaid',
            value: 'unpaid',
          },
          {
            label: 'Defaulting',
            value: 'due',
          },
        ],
      },
    },
  });

  useEffect(() => {
    if (repayments?.getRepaymentsCa) {
      setRepaymentRec(repayments?.getRepaymentsCa);
    }
  }, [repayments]);

  const [getExportRecord] = useCustomQuery({
    query: GET_ADMIN_CUSTOMER_DETAILS_REPAYMENT,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          userId: merchantId,
          offset: 0,
          limit: 2000,
          search,
          filters: {
            from: result.from,
            to: result.to,
            channel: result?.channel,
            status: result?.status,
          },
        },
      });
      if (output?.data) {
        const rec = cleanUpAdminCustomerDetailsRepayment(output?.data?.getRepayments?.repayments);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'REPAYMENTS',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };
  // const routeToMerchantDetails = (data) => {
  //   setItemsToLocalStorage('merchantId', data?.id);
  //   setItemsToLocalStorage('merchant-details-nav-status', {
  //     name: data?.name,
  //     logo: data?.logo,
  //     status: data?.merchantStatus,
  //   });
  //   push(`/merchant-details/${data?.id}/kyc`);
  //   setItemsToLocalStorage('currentRoute', 0);
  // };
  // const [showCommentModal, setShowCommentModal] = useState(false);
  // const [commentContent, setCommentContent] = useState('');
  // const handleClick = (data) => {
  //   // if (data.message) {
  //   //   setShowCommentModal(true);
  //   //   setCommentContent(data.message);
  //   // }
  // };
  return (
    <div>
      <DashboardHeader
        title="Repayments"
        smallSubTitle={`(${repaymentRec?.count || 0})`}
        searchPlaceholder="Search by repayment"
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getRepaymentLoading}
        filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        exportObj={{
          handleExport,
        }}
      />
      <div className="settlement-table-details-cover customer-repayment-cover">
        {repaymentRec?.count ? (
          <AdminTable
            refreshing={getRepaymentLoading}
            page={page}
            setPage={setPage}
            pageSize={limit}
            minHeight="calc(100vh - 280px)"
            count={repaymentRec?.count}
            contents={cleanUpAdminCustomerDetailsRepayment(repaymentRec?.repayments)}
            reference="id"
            hideDominantImage
            clickable
            handleClick={(data) => push(`/repayments/repayment-details/${data?.id}`)}
            hasNameAndImage={hasNameAndImage}
            allowKeyArr={getColumns(true)}
            mobileAllowKeyArr={
              [
                'status',
                ['loanId', 'tenor'],
                ['paymentChannel', 'dueDate'],
              ]
            }
            formatLabels={columnLabelFormat}
          />
        ) : (
          <EmptyRecord
            height="400px"
            title={getRepaymentLoading ? 'Fetching repayments...' : 'No Repayments yet'}
            main="Customer has no repayment."
            // footer="Receive Payments"
            loading={getRepaymentLoading}
            Icon={EmptyMerchantSettlement}
          />
        )}

      </div>
      {/* {
        showCommentModal && <CommentModal comment={commentContent} closeModal={() => setShowCommentModal(false)} />
      } */}

    </div>
  );
};
export default CustomerDetailsRepaymentRecords;
